import React from "react";
import { Text, Timeline, Container, Title, ThemeIcon } from "@mantine/core";
import classes from "./process.module.scss";

const StepBullet = ({ number }) => (
  <ThemeIcon
    size={48}
    radius="xl"
    variant="gradient"
    gradient={{ from: "teal", to: "green" }}
  >
    <Text fw={800} fz="lg" c="white" style={{ lineHeight: 1 }}>
      {number}
    </Text>
  </ThemeIcon>
);

export function ProcessComponent() {
  return (
    <Container size="lg" py={0} className={classes.processContainer}>
      <div className={classes.processWrapper}>
        <span className={classes.eyebrow}>Slik foregår det</span>
        <Title order={2} className={classes.processTitle}>
          Prosessen
        </Title>
        <Timeline
          bulletSize={52}
          lineWidth={3}
          active={5}
          color="teal"
          className={classes.timeline}
        >
          <Timeline.Item
            title="Steg 1: Introduksjonsmøte"
            bullet={<StepBullet number="1" />}
            className={classes.timelineItem}
          >
            <Text c="dimmed" size="sm">
              15 minutter der vi blir kjent og snakker om hvor du står i dag og
              hva du vil oppnå. Vi finner ut om vi er en god match — og hvilken
              plan som passer deg best. Helt uforpliktende.
            </Text>
          </Timeline.Item>
          <Timeline.Item
            title="Steg 2: Innsending av spørreskjema"
            bullet={<StepBullet number="2" />}
            className={classes.timelineItem}
          >
            <Text c="dimmed" size="sm">
              Du fyller ut et omfattende spørreskjema som dekker det viktigste
              jeg trenger for å kunne sette i gang — kosthold, trening, søvn,
              helse og livsstil. Dette danner grunnlaget for en grundig analyse
              av din nåværende situasjon.
            </Text>
          </Timeline.Item>
          <Timeline.Item
            title="Steg 3: Oppstartsmøte"
            bullet={<StepBullet number="3" />}
            className={classes.timelineItem}
          >
            <Text c="dimmed" size="sm">
              90 minutter med grundig kartlegging av situasjonen og målene dine.
              Sammen lager vi en plan du er trygg på og fornøyd med — før vi
              setter i gang for fullt.
            </Text>
          </Timeline.Item>
          <Timeline.Item
            title="Steg 4: Ukentlig oppfølging"
            bullet={<StepBullet number="4" />}
            className={classes.timelineItem}
          >
            <Text c="dimmed" size="sm">
              30 minutter hver uke der vi tar status på hvordan det går, og gjør
              de justeringene som trengs for å holde deg på sporet.
            </Text>
          </Timeline.Item>
          <Timeline.Item
            title="Steg 5: Månedlig status"
            bullet={<StepBullet number="5" />}
            className={classes.timelineItem}
          >
            <Text c="dimmed" size="sm">
              60 minutter etter fire uker der vi går grundig gjennom
              progresjonen fra start. Har du valgt 3–6 måneder, legger vi planen
              for veien videre og gjentar prosessen. Ved 1 måned avslutter vi
              her — med mindre du vil fortsette.
            </Text>
          </Timeline.Item>
        </Timeline>
      </div>
    </Container>
  );
}
